import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import {getAvailableColumns} from "pages/PageRepairTypes/api";

export const path = '/repairTypes';

const PageRepairTypes: React.FC = (props) => {
    const loader = {
        page: () => import('pages/PageRepairTypes/page'),
        columns: getAvailableColumns
    };

    const RepairTypes = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded, loadedProps) {
            const Page = loaded.page.default

            return (
                <Page
                    {...loadedProps}
                    {...props}
                    columns={loaded.columns}
                />
            )
        }
    });

    return <RepairTypes/>;
};

export default PageRepairTypes;
